<template>
  <div>
    <b-modal
        v-model="showModalInternal"
        id="category-products-list-modal"
        scrollable
        :title="title || 'Produkty w kategorii'"
        title-class="font-18"
        hide-footer
        style="z-index:100010!important;"
        size="xl"
    >
      <div v-if="showModalInternal">
        <CategoryProductDataList :categoryGuid="categoryGuid"
        :showMassActions="showMassActions"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import {BModal} from "bootstrap-vue-next";
import CategoryProductDataList from "@/views/DrugstoreCommonManager/CategoryProductDataList.vue";

export default {
  name: "CategoryProductListModal",
  components: { BModal, CategoryProductDataList },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    categoryGuid: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: 'Produkty w kategorii'
    },
    showMassActions: {
      type: Boolean,
      default: () => true
    },
  },
  emits: ["update:showModal"],
  data(){
    return {
      showModalInternal: this.showModal
    }
  },
  watch: {
    showModal(newVal){
      this.showModalInternal = newVal;
    },
    showModalInternal(newVal){
      this.$emit('update:showModal', newVal);
    }
  }
}
</script>

<style scoped>
</style>
